module.exports = __webpack_public_path__ + "fonts/tenez.c929cb1.otf";